import * as BASE from './base';

export function Register(name, email) {

    return BASE.POST('api/register', { name, email });

  // Simulate API call
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       const token = 'mock-token-' + Math.random().toString(36).substr(2, 9);
//       resolve({ token, name, email });
//     }, 1000);
//   });
}

export function ConfirmUser(email, pin) {

    return BASE.POST('api/confirmuser', { email, pin });
  // Simulate API call
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve({ success: true, userToken: 'mock-token-' + Math.random().toString(36).substr(2, 9) });
//     }, 1000);
//   });
}

export function LoadSession(sessionCode) {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, sessionCode });
    }, 1000);
  });
}

export function GetSessionData(sessionCode) {

    return BASE.POST('api/sessiondata', { sessionCode });

//   // Simulate API call
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve({ success: true, sessionCode, data: { 
//             sessionId: 'ABC123',
//             //status: 'waiting to start',
//             status: 'active',
//             quizzes: [
//                 { quiz: 1, image: 'Qs/Q1/Q001.png', answers: 4 },
//                 { quiz: 6, image: 'https://picsum.photos/300/200?random=20', answers: 5 }
//             ] 
//         } });
//     }, 1000);
//   });
}